/* CHITA product-image fit (shared by Season's Edit + Inspired Spaces).
   Product photos come in two framings: padded studio shots (product small in a big canvas) and tight cut-outs.
   A single object-fit can't make both look like the design, and Safari has no object-view-box. So each
   watched <img> is redrawn (same box, same object-fit) into a canvas at its own size, with the product
   placed in a target area of the box:
     crop  : explicit inset [t,r,b,l] fractions (merchant/design crop) drawn with cover, = object-view-box everywhere
     fill  : the detected product bbox is contained in `area`
     guard : leave the photo alone unless, drawn with cover, the product would cross `limit` (fraction of box
             height, e.g. the price row) or the box edges; then fall back to fill.
   Opaque photos get their own corner colour as background, cut-outs stay transparent.
   Cross-origin / tainted images and canvas errors fall back silently to the original <img>. */
(function () {
  if (window.chFit) return;
  var boxes = {}, ro = window.ResizeObserver ? new ResizeObserver(function (es) { es.forEach(function (e) { sched(e.target); }); }) : null;
  /* CORS request: Shopify's CDN (/cdn/shop on the store domain and cdn.shopify.com) answers with Access-Control-Allow-Origin: *,
     so the canvas stays readable even when the page and the image host differ (theme editor, myshopify domain, cdn.shopify.com URLs) */
  function load(src) { return new Promise(function (ok, no) { var i = new Image(); i.crossOrigin = 'anonymous'; i.decoding = 'async'; i.onload = function () { ok(i); }; i.onerror = no; i.src = src; }); }
  /* content bbox (fractions) + background colour of an image, from a 96px thumbnail */
  function analyse(im) {
    var n = 96, w = n, h = Math.max(1, Math.round(n * im.naturalHeight / im.naturalWidth));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data, k = (h - 1) * w * 4, bg = [0, 0, 0, 0];
    [0, (w - 1) * 4, k, k + (w - 1) * 4].forEach(function (o) { for (var j = 0; j < 4; j++) bg[j] += d[o + j] / 4; });
    var clear = bg[3] < 128, x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
      var o = (yy * w + xx) * 4, on = clear ? d[o + 3] > 24 : d[o + 3] > 24 && Math.max(Math.abs(d[o] - bg[0]), Math.abs(d[o + 1] - bg[1]), Math.abs(d[o + 2] - bg[2])) > 28;
      if (on) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
    }
    if (x1 < 0) return { b: [0, 0, 1, 1], bg: clear ? null : bg };
    return { b: [x0 / w, y0 / h, (x1 + 1) / w, (y1 + 1) / h], bg: clear ? null : bg };
  }
  function restore(img) {
    if (!img._fitOrig) return;
    var o = img._fitOrig; img._fitOrig = null; img.classList.remove('is-fit');
    if (o.srcset) img.setAttribute('srcset', o.srcset); if (o.sizes) img.setAttribute('sizes', o.sizes);
    img.src = o.src; if (img._fitUrl) { URL.revokeObjectURL(img._fitUrl); img._fitUrl = null; }
  }
  var pend = new Set(), raf = 0;
  function sched(img) { pend.add(img); if (!raf) raf = requestAnimationFrame(function () { raf = 0; var a = Array.from(pend); pend.clear(); a.forEach(run); }); }
  function run(img) {
    var opt = img._fitOpt && img._fitOpt(img);
    var W = img.clientWidth, H = img.clientHeight;
    if (!opt) { img._fitKey = null; restore(img); return; }
    if (W < 2 || H < 2) return;
    /* QA13 #27-7: above 1440 the homepage sections are CSS-zoomed (--ch-scale); clientWidth is the unzoomed size, so the canvas must be
       drawn at the zoomed (on-screen) size too, or it is blown up by the zoom factor (~1.8x at 2560) */
    var z = 1; try { var gw = img.getBoundingClientRect().width; if (gw > 0) z = Math.max(1, Math.min(4, gw / W)); } catch (e) {}
    var key = W + 'x' + H + '@' + z.toFixed(3) + '|' + JSON.stringify(opt);
    if (img._fitKey === key) return;
    /* 10/28 performance: only once the browser has loaded the photo itself (its srcset pick). Before, a lazy photo that had not loaded yet
       (cards outside the visible track) was fetched here from its fallback src - the largest width - which defeated lazy loading and
       downloaded a second, bigger copy of the same photo. The load listener in watch() schedules it again. */
    if (!img._fitOrig && !(img.complete && img.naturalWidth && img.currentSrc)) return;
    var src = img._fitOrig ? img._fitOrig.src : (img.currentSrc || img.src);
    if (!src || /^data:/.test(src)) return;
    var tok = img._fitTok = {};
    (boxes[src] || (boxes[src] = load(src).then(function (im) { var a = null; try { a = analyse(im); } catch (e) {} return { im: im, a: a }; }))).then(function (r) {
      if (img._fitTok !== tok) return;
      var im = r.im, nw = im.naturalWidth, nh = im.naturalHeight, b, cover = false;
      if (opt.crop) { b = [opt.crop[3], opt.crop[0], 1 - opt.crop[1], 1 - opt.crop[2]]; cover = true; }
      else if (r.a) b = r.a.b; else { img.classList.add('is-fitfb'); return; } /* unreadable: keep the plain <img>, styled by the section's .is-fitfb fallback */
      var bw = (b[2] - b[0]) * nw, bh = (b[3] - b[1]) * nh, s, dx, dy;
      if (opt.mode === 'guard') {
        var sc = Math.max(W / nw, H / nh), ox = (W - nw * sc) / 2, oy = (H - nh * sc) / 2;
        var px0 = ox + b[0] * nw * sc, px1 = ox + b[2] * nw * sc, py1 = oy + b[3] * nh * sc;
        /* keep at least half of the design side margin, so an edge-to-edge cut-out doesn't touch the card sides */
        var mg = opt.area ? opt.area[0] * W / 2 : 0;
        if (py1 <= opt.limit * H && px0 >= mg - 1 && px1 <= W - mg + 1) { img._fitKey = key; restore(img); return; }
      }
      var A = opt.area || [0, 0, 1, 1], ax = A[0] * W, ay = A[1] * H, aw = A[2] * W, ah = A[3] * H;
      s = cover ? Math.max(aw / bw, ah / bh) : Math.min(aw / bw, ah / bh);
      dx = ax + (aw - bw * s) / 2 - b[0] * nw * s; dy = ay + (ah - bh * s) / 2 - b[1] * nh * s;
      var k = Math.min(window.devicePixelRatio || 1, 3) * z;
      /* zoomed-in product would be upscaled: draw from a larger Shopify CDN rendition (?width=N) instead (other URL params, e.g. the
         static-GIF format=pjpg, are kept). 10/28 performance: phones (<750px) only when the photo would be blown up by more than 1.5x at
         2x density (a second download of the same photo otherwise), sized for at most 2x and capped at 1100w
         (was up to 3000w at 3x); never at or above the original width (data-maxw: the CDN would return the untouched original, for a GIF
         the full animation); desktop otherwise unchanged */
      var ph = window.innerWidth < 750, need = nw * s * (ph ? Math.min(k, 2) : k), tw = Math.min(ph ? 1100 : 3000, Math.ceil(need / 100) * 100, (+img.getAttribute('data-maxw') || 1e9) - 1),
        m = need > nw * (ph ? 1.5 : 1.1) && tw > nw && /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + tw) : null;
      if (m) (boxes[m] || (boxes[m] = load(m).then(function (hi) { return { im: hi }; }))).then(function (h) { if (img._fitTok === tok) draw(h.im); }, function () { if (img._fitTok === tok) draw(im); });
      else draw(im);
      function draw(im2) {
      var c = document.createElement('canvas');
      c.width = Math.round(W * k); c.height = Math.round(H * k);
      var x = c.getContext('2d'); x.imageSmoothingQuality = 'high';
      var bg = r.a && r.a.bg; if (bg && !cover) { x.fillStyle = 'rgb(' + Math.round(bg[0]) + ',' + Math.round(bg[1]) + ',' + Math.round(bg[2]) + ')'; x.fillRect(0, 0, c.width, c.height); }
      x.drawImage(im2, dx * k, dy * k, nw * s * k, nh * s * k);
      try {
        c.toBlob(function (bl) {
          c.width = c.height = 0; /* free the backing store now (iOS caps total canvas memory) */
          if (!bl || img._fitTok !== tok) return;
          if (!img._fitOrig) { img._fitOrig = { src: src, srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes') }; }
          img.removeAttribute('srcset'); img.removeAttribute('sizes');
          var old = img._fitUrl; img._fitUrl = URL.createObjectURL(bl); img.src = img._fitUrl; img.classList.add('is-fit'); img.classList.remove('is-fitfb'); img._fitKey = key;
          if (old) URL.revokeObjectURL(old);
        });
      } catch (e) { c.width = c.height = 0; img.classList.add('is-fitfb'); /* tainted canvas */ }
      }
    }, function () { if (img._fitTok === tok) img.classList.add('is-fitfb'); });
  }
  window.chFit = {
    /* imgs: NodeList/array of <img>; opt(img) -> options object, or null to show the original photo */
    watch: function (imgs, opt) {
      [].forEach.call(imgs, function (img) {
        img._fitOpt = opt;
        if (img.complete && img.naturalWidth) sched(img);
        img.addEventListener('load', function () { if (!/^blob:/.test(img.src)) sched(img); });
        if (ro) ro.observe(img);
      });
      window.addEventListener('resize', function () { [].forEach.call(imgs, sched); });
    },
    refresh: function (imgs) { [].forEach.call(imgs, function (i) { i._fitKey = null; sched(i); }); },
    /* QA8: fetch + analyse a watched photo ahead of time (e.g. in a hidden tab panel, where it cannot be drawn yet), so framing it
       when its panel is shown only costs the canvas draw */
    prime: function (img) {
      if (!img || !img._fitOpt) return; var src = img._fitOrig ? img._fitOrig.src : (img.currentSrc || img.src);
      if (!src || /^(data|blob):/.test(src) || boxes[src]) return;
      boxes[src] = load(src).then(function (im) { var a = null; try { a = analyse(im); } catch (e) {} return { im: im, a: a }; });
      boxes[src].catch(function () {});
    }
  };
})();
